import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{ 
      background: '#1A1B1E', 
      color: 'white', 
      padding: '60px 0 0',
      fontFamily: "'Inter', sans-serif"
    }}>
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-grid" style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '40px', 
          marginBottom: '40px' 
        }}>
          {/* Company Info */}
          <div className="footer-company" style={{ maxWidth: '350px' }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_8df07f88-bc0e-485a-bdfa-23d100a34040/artifacts/yx81ddm2_rjlogo%20%283%29.png" 
              alt="Right Shade Logo" 
              style={{ height: '60px', marginBottom: '20px', display: 'block' }}
            />
            <p style={{ 
              color: 'rgba(255,255,255,0.7)', 
              lineHeight: 1.6,
              fontSize: '14px',
              marginBottom: '20px'
            }}>
              Building world-class sports facilities and premium construction projects across India with over 15 years of expertise.
            </p>
            
            {/* Social Media Icons */}
            <div style={{ display: 'flex', gap: '12px' }}>
              <a 
                href="https://www.facebook.com/profile.php?id=61566846243053&mibextid=ZbWKwL" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '1px solid rgba(255,255,255,0.3)',
                  textDecoration: 'none',
                  background: 'transparent'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.color = '#FFD700';
                  e.currentTarget.style.borderColor = '#FFD700';
                  e.currentTarget.style.background = 'rgba(255,215,0,0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.instagram.com/right.shade?igsh=c251ZXpraXVtcjI0" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '1px solid rgba(255,255,255,0.3)',
                  textDecoration: 'none',
                  background: 'transparent'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.color = '#FFD700';
                  e.currentTarget.style.borderColor = '#FFD700';
                  e.currentTarget.style.background = 'rgba(255,215,0,0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://youtube.com/@rightshadesports?si=5fqS2fZbzGxwVe0y" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="YouTube"
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  border: '1px solid rgba(255,255,255,0.3)',
                  textDecoration: 'none',
                  background: 'transparent'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.color = '#FFD700';
                  e.currentTarget.style.borderColor = '#FFD700';
                  e.currentTarget.style.background = 'rgba(255,215,0,0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
          
          {/* Links Wrapper - Contains Quick Links & Services side by side on mobile */}
          <div className="footer-links-wrapper" style={{ display: 'contents' }}>
            {/* Quick Links */}
            <div className="footer-quick-links">
            <h4 style={{ 
              fontSize: '18px', 
              fontWeight: 600, 
              marginBottom: '20px',
              color: 'white'
            }}>
              Quick Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link 
                to="/" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                About Us
              </Link>
              <Link 
                to="/projects" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Projects
              </Link>
              <Link 
                to="/contact" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Contact Us
              </Link>
              <Link 
                to="/blogs" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Blogs
              </Link>
            </div>
          </div>
          
            {/* Services */}
            <div className="footer-services">
            <h4 style={{ 
              fontSize: '18px', 
              fontWeight: 600, 
              marginBottom: '20px',
              color: 'white'
            }}>
              Our Services
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link 
                to="/sports" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Sports Courts
              </Link>
              <Link 
                to="/construction" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Construction
              </Link>
              <Link 
                to="/sports/pickleball-courts" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Pickleball Courts
              </Link>
              <Link 
                to="/sports/football-turf" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Football Turf
              </Link>
              <Link 
                to="/construction/court-structures" 
                style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s'
                }}
                onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
              >
                Court Structures
              </Link>
            </div>
          </div>
          </div>
          
          {/* Contact Info */}
          <div className="footer-contact">
            <h4 style={{ 
              fontSize: '18px', 
              fontWeight: 600, 
              marginBottom: '20px',
              color: 'white'
            }}>
              Contact Info
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <MapPin size={18} style={{ color: '#FFD700', flexShrink: 0, marginTop: '2px' }} />
                <p style={{ 
                  color: 'rgba(255,255,255,0.7)', 
                  fontSize: '14px',
                  margin: 0,
                  lineHeight: 1.5
                }}>
                  RT Nagar, Bengaluru 560032, Karnataka, India
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Phone size={18} style={{ color: '#FFD700', flexShrink: 0 }} />
                <a 
                  href="tel:+919964660033"
                  style={{ 
                    color: 'rgba(255,255,255,0.7)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                  onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
                >
                  +91 99646 60033
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Mail size={18} style={{ color: '#FFD700', flexShrink: 0 }} />
                <a 
                  href="mailto:rajashekar@rightshade.in"
                  style={{ 
                    color: 'rgba(255,255,255,0.7)', 
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.3s',
                    wordBreak: 'break-word'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.color = '#FFD700'}
                  onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
                >
                  rajashekar@rightshade.in
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div style={{ 
          paddingTop: '30px',
          paddingBottom: '30px',
          borderTop: '1px solid rgba(255,215,0,0.2)',
          textAlign: 'center'
        }}>
          <p style={{ 
            color: 'rgba(255,255,255,0.6)',
            fontSize: '14px',
            margin: 0
          }}>
            © 2025 Right Shade. All rights reserved. | Building Excellence Since 2009
          </p>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 40px 30px !important;
          }
        }
        
        @media (max-width: 768px) {
          footer {
            padding: 50px 0 0 !important;
          }
          
          .footer-grid {
            display: flex !important;
            flex-direction: column !important;
            gap: 35px !important;
          }
          
          /* Company Info - Full Width, Centered */
          .footer-company {
            text-align: center;
            max-width: 100% !important;
          }
          
          .footer-company img {
            margin: 0 auto 20px !important;
          }
          
          .footer-company > div {
            justify-content: center !important;
          }
          
          /* Links Wrapper - Create 2-column layout for Quick Links & Services */
          .footer-links-wrapper {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            gap: 20px !important;
            width: 100%;
          }
          
          .footer-quick-links,
          .footer-services {
            text-align: left !important;
          }
          
          .footer-quick-links h4,
          .footer-services h4 {
            font-size: 16px !important;
            margin-bottom: 16px !important;
          }
          
          .footer-quick-links a,
          .footer-services a {
            font-size: 13px !important;
          }
          
          /* Contact Info - Full Width, Centered */
          .footer-contact {
            text-align: center;
          }
          
          .footer-contact > div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          
          .footer-contact > div > div {
            justify-content: center !important;
          }
          
          footer > div > div:last-child {
            padding: 25px 0 !important;
          }
        }
        
        @media (max-width: 480px) {
          .footer-quick-links h4,
          .footer-services h4 {
            font-size: 15px !important;
          }
          
          .footer-quick-links a,
          .footer-services a {
            font-size: 12px !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;